<dx-tree-view [dataSource]="dataSource()" [items]="items()" [displayExpr]="displayExpr()" [itemsExpr]="itemsExpr()" [keyExpr]="keyExpr()" [height]="height()"
  [itemTemplate]="itemTemplate()? 'itemTemplate' : 'item'" [parentIdExpr]="parentIdExpr()" [dataStructure]="dataStructure()"
  [virtualModeEnabled]="virtualModeEnabled()" [rootValue]="null" (onItemClick)="onItemClick($event)" (onItemSelectionChanged)="onItemSelectionChanged($event)">

  <div *dxTemplate="let data of 'itemTemplate'">
    <ng-template [ngTemplateOutlet]="itemTemplate()" [ngTemplateOutletContext]="{ $implicit: data }"></ng-template>
  </div>

</dx-tree-view>
